export default __webpack_public_path__ + "static/media/697.366481ad.png";